export default __webpack_public_path__ + "static/char-11-c593ca56f6a8ca42e6f2c84ec2b456aa.webp";